export default "__VITE_ASSET__BjADxVGj__"